import styled from 'styled-components';
import colors from '@/main/style/colors';
import bgLoginQualitas from '../../../../assets/images/homepage/background_login_qualitas.png';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: #E8E8E8;
  background-image: url(${bgLoginQualitas});
  background-repeat: no-repeat;
  background-size: cover;
  overflow-x: hidden;
  z-index: 0;
  @media (max-width: 1025px) {
    background-position: center;
  }
`;

export const ConfirmPasswordCard = styled.div`
  position: relative;
  background-color: ${colors.white};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 3rem 2.5rem;
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 50vh;

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
    max-width: 400px;
  }
`;

export const AreaBackButton = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButton = styled.div`
  background: #941b80;
  border-radius: 50%;
  color: white;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: filter 0.2s;
  
  &:hover {
    filter: brightness(1.1);
  }
`;

export const AreaLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  width: 100%;

  img {
    width: 100%;
    max-width: 180px;
    height: auto;

    @media (max-width: 768px) {
      max-width: 120px;
    }
  }
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
  padding: 0 2.6rem;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 600;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 2rem;
`;
